import { ONBOARDING_STATE } from '@/constants';
import { atomWithUniqueKey } from '@/utils';

export type OnboardingState = {
  loading: boolean;
  termsHasBeenAccepted: boolean;
  loaded: boolean;
};

export const useOnboardingState = atomWithUniqueKey<OnboardingState>({
  key: ONBOARDING_STATE,
  default: {
    loading: false,
    termsHasBeenAccepted: false,
    loaded: false,
  },
});
